import { render, staticRenderFns } from "./VesselRecordShipTypePieChart.vue?vue&type=template&id=18582cf4&scoped=true&"
import script from "./VesselRecordShipTypePieChart.vue?vue&type=script&lang=js&"
export * from "./VesselRecordShipTypePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18582cf4",
  null
  
)

export default component.exports